import { render, staticRenderFns } from "./ServiceBatchEdit.vue?vue&type=template&id=5ee64706"
import script from "./ServiceBatchEdit.vue?vue&type=script&lang=js"
export * from "./ServiceBatchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports